import { Dialog } from '@mui/material';
import DetailsPopUpContent from 'shared/components/details-pop-up-content/details-pop-up-content';
import LoadingIndicator from 'shared/components/loading-indicator/loading-indicator';

import { useDeviceDetailsHook } from 'features/device/device-details/hooks/device-details-hook';
import DeviceDetailsPopupHeader from 'features/device/device-details/views/device-details-popup-header.component';
import DeviceDetailsPopupInformation from 'features/device/device-details/views/device-details-popup-information/device-details-popup-information';

import 'features/device/device-details/views/device-details-popup.component.scss';

import { ReactElement } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PopUp from 'shared/components/pop-up/pop-up';

import DeviceDetailsPopupSettings from 'features/device/device-details/views/device-details-settings/device-details-popup-settings.component';
import { SendTestEventProvider } from 'features/device/send-test-event/context/send-test-event-provider';

type Props = {
  onCloseCallback?: () => void;
};

const DeviceDetailsPopup = ({ onCloseCallback }: Props): ReactElement => {
  const { t } = useTranslation('deviceDetails');

  const {
    submitDevice,
    handleClosePopup,
    form,
    isPopupOpen,
    isLoading,
    showIpUnitUnreachableError,
    setShowIpUnitUnreachableError,
    currentDevice,
  } = useDeviceDetailsHook();

  return (
    <>
      <Dialog
        open={isPopupOpen}
        onClose={() => handleClosePopup(onCloseCallback)}
        className="device-details-popup"
        slotProps={{
          paper: { classes: { root: 'device-details-popup-paper' } },
        }}
      >
        <FormProvider {...form}>
          <DetailsPopUpContent
            onSubmit={form.handleSubmit(submitDevice)}
            leftContent={isLoading ? <></> : <DeviceDetailsPopupInformation />}
            rightContent={isLoading ? <LoadingIndicator /> : <DeviceDetailsPopupSettings />}
            header={
              <SendTestEventProvider>
                <DeviceDetailsPopupHeader onCloseCallback={onCloseCallback} />
              </SendTestEventProvider>
            }
          />
        </FormProvider>
      </Dialog>
      <PopUp
        isOpen={showIpUnitUnreachableError}
        title={t('ipUnitUnreachable.title', { deviceName: currentDevice?.name })}
        body={t('ipUnitUnreachable.bodyText')}
        primaryButtonText={t('ipUnitUnreachable.confirmButton')}
        handleOnClose={() => setShowIpUnitUnreachableError(false)}
        primaryButtonAction={() => setShowIpUnitUnreachableError(false)}
      />
    </>
  );
};

export default DeviceDetailsPopup;
